import { render, staticRenderFns } from "./PlotDetail.vue?vue&type=template&id=4550baf8&"
import script from "./PlotDetail.vue?vue&type=script&lang=js&"
export * from "./PlotDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlotDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports